import {lazy, Suspense} from 'react'
import {selectApplicationEntry} from '../config/entry'

const DebugExperienceApp = lazy(async () => {
  const module = await import('./LegacyLabApp')
  return {default: module.DebugExperienceApp}
})

const ProductApp = lazy(async () => {
  const module = await import('./product/ProductApp')
  return {default: module.ProductApp}
})

const DesktopHandoffPage = lazy(async () => {
  const module = await import('./DesktopHandoffPage')
  return {default: module.DesktopHandoffPage}
})

export function App() {
  const entry = selectApplicationEntry(window.location.search, {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints,
  })

  return (
    <Suspense fallback={<EntryLoadingFallback />}>
      {entry === 'debug' && <DebugExperienceApp />}
      {entry === 'product' && <ProductApp />}
      {entry === 'desktop-handoff' && <DesktopHandoffPage />}
    </Suspense>
  )
}

function EntryLoadingFallback() {
  return (
    <main className="entry-loading" aria-busy="true" aria-live="polite">
      <span className="loader" aria-hidden="true" />
      <span>Loading Every Little Heart Matters AR…</span>
    </main>
  )
}
